export default __webpack_public_path__ + "static/media/product-12 (1).35b8b824.jpg";